require.register("modules/m02/m02-activity/page-14-il/page-14-il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page14_il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page14_il;

  
});

